export const STATUS_COLORS = [
    '#868686',
    '#C6FFD9',
    '#CFEAFF',
    '#DBFFC1',
    '#E7E9EB',
    '#EADDFF',
    '#FFDBFA',
    '#FFDCDB',
    '#FFFABB',
] as const

// Label chips are pastel so `--black` text stays readable on them. A label created from
// the task picker (no room for a swatch there) takes the next color in this order, so a
// fresh workspace gets visually distinct labels before anyone opens the settings tab.
export const LABEL_COLORS = [
    '#DBFFC1',
    '#EADDFF',
    '#CFEAFF',
    '#FFFABB',
    '#FFDBFA',
    '#FFDCDB',
] as const

export const DEFAULT_LABEL_COLOR = LABEL_COLORS[0]

// Labels created before the color field existed have no `color` — resolve at read time
// instead of assuming a migration touched every doc.
export const labelColor = (color: string | null | undefined): string =>
    color || DEFAULT_LABEL_COLOR

export const nextLabelColor = (usedColors: (string | null | undefined)[]): string => {
    const counts = new Map<string, number>(LABEL_COLORS.map(c => [c, 0]))
    for (const color of usedColors) {
        const key = labelColor(color)
        if (counts.has(key)) counts.set(key, counts.get(key)! + 1)
    }
    // Least-used wins; ties break on palette order, so the first six labels are all distinct.
    return LABEL_COLORS.reduce((best, color) =>
        counts.get(color)! < counts.get(best)! ? color : best, LABEL_COLORS[0])
}
